var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_vm._m(0),_c('iframe',{staticStyle:{"width":"100%","height":"800px"},attrs:{"src":_vm.iframeUrl,"frameborder":"0"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-headline"},[_c('h1',[_vm._v("DP Jobs")])])
}]

export { render, staticRenderFns }